// import './profile.scss';

export { default } from './Profile';
export { default as template } from './profile.tpl';
